
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import Card from "@/components/card/Card.vue";
import Processing from "@/components/common/Processing.vue";
import { displayTimeInLocationTimezone, deserializeTimezone, getTimezoneFromLocationString } from "@/utils/timezoneUtils";
import { VUE_GOOGLEMAP_API_KEY } from "@/data/constants";
import UIButton from "@/components/button/ui-button.vue";
import ItemChip from "@/components/common/ItemChip.vue";
import ActivityHoursUnconfirmedAlert from "@/components/projects/activities/ActivityHoursUnconfirmedAlert.vue";
import TimeTrackerModal from "@/components/projects/timeTracker/TimeTrackerModalNew.vue";
import RouteNames from "@/entities/RouteNames";
import ClockIcon from "@/components/icons/clockIconNew.vue";
import ClockIconBlack from "@/components/icons/Clock-icon-black.vue";
import {
  Project,
  Project_Activity,
  Timesheet_Bool_Exp,
  User,
} from "@/generated/graphql";
import CalendarIcon from "@/components/icons/ClanderGray.vue";
import LocationIcon from "@/components/icons/ClockGray.vue";
import StarIcon from "@/components/icons/StartGray.vue";
import DollarIcon from "@/components/icons/dollar-symbol.vue";
import NotesView from "@/components/icons/NotesView.vue";
import NotesModal from "@/components/projects/activities/NotesModal.vue";
import visitTypeDisplayMap from "@/entities/VisitType";
import CardInfoChip from "@/components/card/CardInfoChip.vue";
import PROJECT_ACTIVITY_TIME_AGGREGATE from "@/apollo/projectActivities/ProjectActivityTimeAggregate.gql";
import DeclinedReasonConversationModal from "@/components/projects/timeTracker/DeclinedReasonConversationModal.vue";
import ViewRequestedHoursDeclineReasonModal from "@/components/projects/timeTracker/ViewRequestedHoursDeclineReasonModal.vue";
import GET_TIMEHSEET from "@/apollo/timesheet/GetTimesheet.gql";
import INSERT_TIMESHEET from "@/apollo/projectActivities/InsertTimesheetEntry.gql";
import { getStartAndEndOfWeek } from "@/utils";
import ContractorClockInModal from "./ContractorClockInModal.vue";
type IProjectType = Project_Activity & {
  total_notes: {
    aggregate: {
      count: number;
    };
  };
};
enum ClockType {
  IN = "IN",
  OUT = "OUT",
}

@Component({
  components: {
    Card,
    ContractorClockInModal,
    NotesModal,
    NotesView,
    ClockIcon,
    UIButton,
    ClockIconBlack,
    CardInfoChip,
    CalendarIcon,
    LocationIcon,
    StarIcon,
    Processing,
    DollarIcon,
    ItemChip,
    ActivityHoursUnconfirmedAlert,
    TimeTrackerModal,
    DeclinedReasonConversationModal,
    ViewRequestedHoursDeclineReasonModal,
  },
  apollo: {
    timeAggregate: {
      query: PROJECT_ACTIVITY_TIME_AGGREGATE,
      variables() {
        return {
          activityId: this.activity?.id,
        };
      },
      update: (data) => data.project_activity_time_aggregate.aggregate.sum.time,
    },
    $subscribe: {
      timeAggregate: {
        query: PROJECT_ACTIVITY_TIME_AGGREGATE,
        variables() {
          return {
            activityId: this.activity?.id,
          };
        },
        update: (data) =>
          data.project_activity_time_aggregate.aggregate.sum.time,
      },
    },
  },
})
// extent Project_Activity type add total_notes field

export default class ActivityItem extends Vue {
  @Prop({ type: Object, required: true })
  readonly activity!: IProjectType;
  @Prop({ type: Object, required: true }) readonly project!: Project;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: Boolean, default: false })
  readonly redirectToContractor!: object;
  @Prop({ type: Boolean, default: false }) readonly frozen!: boolean;
  @Prop({ type: Boolean, default: false }) readonly processing!: boolean;
  @Prop({ type: Boolean, default: false }) readonly warningShown!: boolean;
  @Prop({ type: String, default: undefined }) readonly companyId?: string;
  @Prop({ type: String, default: undefined })
  readonly approvedTimesSum?: string;
  @Prop({ type: String, default: undefined })
  readonly moreHoursRequest?: string;

  declineReasonData: [] = undefined;
  showNotesModal: boolean = false;
  isContractorClockInModal: boolean = false;
  showDeclinedReasonConversationModal: boolean = false;
  requestedHoursDeclineReasonModal: boolean = false;
  routes = RouteNames;
  timeTrackerModalOpened = false;
  clockInModalOpened = false;
  hovering = false;
  logHourIconhovering = false;
  currentUser: User = Vue.prototype.$currentUser;
  timeAggregate: number = 0;
  locationTimezone: any = null;

  timesheetWhere(date: Date): Timesheet_Bool_Exp {
    const comapnyId = this.companyId || this.project.company_id;
    return {
      _and: [{ start_date: { _lte: date } }, { end_date: { _gte: date } }],
      company_id: { _eq: comapnyId },
      contractor_id: { _eq: this.activity.contractor_id },
    };
  }
  async createTimeSheet(date: Date) {
    const comapnyId = this.companyId || this.project.company_id;
    const [start, end] = getStartAndEndOfWeek(date);
    try {
      const timesheetRes = await this.$apollo.mutate({
        mutation: INSERT_TIMESHEET,
        variables: {
          timesheet: {
            contractor_id: this.activity.contractor_id,
            user_id: this.currentUser.id,
            company_id: comapnyId,
            start_date: moment(start).format("YYYY-MM-DD"),
            end_date: moment(end).format("YYYY-MM-DD"),
            type: "WEEKLY",
            status: "UNSUBMITTED",
            tracked_time: 0,
          },
        },
      });
      return timesheetRes.data?.insert_timesheet_one?.id;
    } catch (error) { }
  }
  get notesButtonText() {
    if (this.activity.extra_notes) {
      return `Notes (${this.activity?.total_notes?.aggregate.count + 1})`
    }
    return 'Notes';
  }
  async checkDateWeekDisable(date: Date) {
    let response = { isDisable: false, id: null };
    const dateMilis = new Date(date).getTime();
    try {
      if (this.activity.contractor_id) {
        const timesheetRes = await this.$apollo.query({
          query: GET_TIMEHSEET,
          variables: {
            where: this.timesheetWhere(date),
            distinct_on: "id",
          },
        });
        const timesheet = timesheetRes.data?.timesheet?.[0];
        if (timesheet) {
          const startTime = new Date(timesheet.start_date).getTime();
          const endTime = new Date(timesheet.end_date).getTime();
          const isBetween = dateMilis <= endTime && dateMilis >= startTime;
          response = { isDisable: false, id: timesheet.id };
          if (
            isBetween &&
            timesheet.status !== "REJECTED" &&
            timesheet.status !== "UNSUBMITTED"
          ) {
            response = { isDisable: true, id: null };
          }
        } else {
          const timesheetId = await this.createTimeSheet(date);
          response = { isDisable: false, id: timesheetId };
        }
      } else {
        response = { isDisable: true, id: null };
      }
    } catch (e) {
      response = { isDisable: true, id: null };
    }

    return response;
  }

  get googleMapsLink(): string {
    const baseMapsUrl = "https://www.google.com/maps/search/?api=1";
    const queryParam = `query=${encodeURIComponent(this.location)}`;
    return `${baseMapsUrl}&${queryParam}`;
  }

  get assignedOnDate(): string {
    if (this.activity.contractor_updated_at) {
      const date = moment(this.activity.contractor_updated_at).format(
        "DD MMM, YYYY"
      );
      return `${date}`;
    }
    return "n/a";
  }
  get showLogHours(): boolean {
    return Boolean(this.activity.checkout_time);
  }

  getVisitType(type: string | undefined): string {
    if (!type) return "n/a";
    return (
      visitTypeDisplayMap[type] ||
      type
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
    );
  }

  get typeOfVisit(): string {
    return this.getVisitType(this.activity?.type_of_visit);
  }
  get location(): string {
    const address = this.activity.location;
    return address && address.trim();
  }


  get startTime(): string {
    if (!this.activity?.start_time) return "n/a";

    if (this.locationTimezone) {
      try {
        return displayTimeInLocationTimezone(this.activity.start_time, this.locationTimezone, "h:mm A");
      } catch (error) {
        console.error("Error formatting time with timezone:", error);
      }
    }

    try {
      const time = this.$moment(this.activity.start_time);
      if (!time.isValid()) return "Invalid Time";

      return time.minutes() > 0
        ? time.format("h:mm A")
        : time.format("h A");
    } catch {
      return "Invalid Time";
    }
  }
  get endTime(): string {
    if (!this.activity?.end_time) return "n/a";

    if (this.locationTimezone) {
      try {
        return displayTimeInLocationTimezone(this.activity.end_time, this.locationTimezone, "h:mm A");
      } catch (error) {
        console.error("Error formatting time with timezone:", error);
      }
    }

    try {
      const time = this.$moment(this.activity.end_time);
      if (!time.isValid()) return "Invalid Time";

      return time.minutes() > 0
        ? time.format("h:mm A")  // Show minutes (e.g., "12:30 PM")
        : time.format("h A");    // Hide minutes when zero (e.g., "12 PM")
    } catch {
      return "Invalid Time";
    }
  }
  get totalHours(): string {
    // Check if start_time and end_time are valid
    if (!this.activity?.start_time || !this.activity?.end_time) {
      return;
    }

    // Ensure the times are in a valid format
    const startTimeString = this.formatTime(this.activity.start_time);
    const endTimeString = this.formatTime(this.activity.end_time);

    if (!startTimeString || !endTimeString) {
      return "Invalid Time";
    }

    try {
      const startTime = this.$moment(startTimeString); // Parse start time
      const endTime = this.$moment(endTimeString); // Parse end time

      if (!startTime.isValid() || !endTime.isValid()) {
        return "Invalid Time";
      }

      const durationInMinutes = endTime.diff(startTime, "minutes"); // Get total minutes
      if (durationInMinutes < 0) {
        return "Invalid Time";
      }

      const hours = Math.floor(durationInMinutes / 60); // Get full hours
      const minutes = durationInMinutes % 60; // Get remaining minutes

      if (hours > 0 && minutes > 0) {
        return `(${hours}h ${minutes}m)`;
      } else if (hours > 0) {
        return `(${hours} hours)`;
      } else {
        return `(${minutes}m)`;
      }
    } catch (error) {
      console.error("Error calculating time difference:", error);
      return "Invalid Time";
    }
  }


  // Helper function to format the time
  formatTime(time: any): string | null {
    if (typeof time === "string") {
      return time; // If it's already a valid string, return it
    }

    // If it's an object like {HH: "05", mm: "00"}, format it into HH:mm
    if (time && time.HH && time.mm) {
      return `${time.HH}:${time.mm}`;
    }

    return null;
  }

  get isCurrentClockType() {
    if (this.activity.checkin_status) {
      return ClockType.OUT;
    }
    return ClockType.IN;
  }

  get isClockedIn() {
    if (this.activity.checkin_status) {
      return true;
    }
    return false;
  }

  get isClockedOut() {
    if (this.activity.checkout_status) {
      return true;
    }
    return false;
  }

  toggleContractorClockInModal(status: boolean) {
    this.isContractorClockInModal = status;
  }

  handleShow() {
    this.showNotesModal = true;
  }

  handleClose() {
    this.showNotesModal = false;
  }

  get isWithinClockInWindow(): boolean {
    if (!this.activity.start_time || !this.activity.start_date) return false;

    const now = moment().utc();
    const startDate = moment.utc(this.activity.start_date);
    const startTime = moment.utc(this.activity.start_time);

    // If now is before or same as start_date, allow clock-in
    if (now.isSameOrBefore(startDate, 'day')) {
      const latestAllowed = startTime.clone().add(10, "minutes");
      return now.isSameOrBefore(latestAllowed);
    }
  }

  get startDate(): string | undefined {
    if (!this.activity.start_date) {
      return undefined;
    }

    return moment(this.activity.start_date).format("DD MMM YYYY");
  }
  get endDate(): string | undefined {
    if (!this.activity.end_date) {
      return undefined;
    }

    return moment(this.activity.end_date).format("DD MMM YYYY");
  }

  get isCompleted(): boolean {
    return !this.frozen && this.activity.completed;
  }

  get createdAt(): string {
    const date = moment(this.activity.start_date).format("DD MMM, YYYY");
    return `${date}`;
  }

  openTimeTrackerModal(): void {
    this.timeTrackerModalOpened = true;
  }

  openClockInModal(): void {
    this.clockInModalOpened = true;
  }

  get isContractor(): boolean {
    if (!this.currentUser) {
      return false;
    }
    if (this.currentUser.role.toUpperCase() === "CONTRACTOR") {
      return true;
    }
    return false;
  }

  async mounted() {
    await this.loadLocationTimezone();
  }

  async loadLocationTimezone() {
    // First try to use stored timezone from activity
    if (this.activity.timezone) {
      try {
        this.locationTimezone = deserializeTimezone(this.activity.timezone);
        if (this.locationTimezone) {
          return; // Successfully loaded from stored data
        }
      } catch (error) {
        console.error("Error deserializing stored timezone:", error);
      }
    }

    // If no stored timezone or deserialization failed, try to get from location
    if (this.activity.location && VUE_GOOGLEMAP_API_KEY) {
      try {
        this.locationTimezone = await getTimezoneFromLocationString(
          this.activity.location,
          VUE_GOOGLEMAP_API_KEY
        );
      } catch (error) {
        console.error("Error fetching timezone from location:", error);
        this.locationTimezone = null;
      }
    }
  }

  @Watch("timeAggregate")
  emitTimeAggregrateChange(): void {
    this.$emit("timeAggregateChanged");
  }
}
